<template>
  <div v-if="showError" class="error-pane uk-text-center uk-card uk-padding-small uk-animation-slide-bottom">
    <span class="uk-margin-small-right">{{ $t("update_panel.description") }}</span>

    <button class="update-button uk-button uk-button-primary" @click="refresh">
      <span class="uk-margin-small-left uk-margin-small-right" uk-icon="refresh" />
      <span class="uk-margin-small-right uk-margin-remove-left">{{ $t("dialog.refresh") }}</span>
    </button>
  </div>
</template>

<script>

/**
 * RouterErrorMessage component.
 *
 * Shows an error panel/message if an error occurs during route change and option for end-user
 * to refresh the page. This was implemented to counter ChunkLoadErrors that may occur after
 * an update has been rolled. For more details see FLOW-4336.
 *
 * @author Documill 2025
 */

import $ from 'jquery';

export default {
  name: 'RouterErrorMessage',

  emits: ['error'],

  data: function() {
    return {
      showError: false
    }
  },

  props: {

  },

  computed: {

  },

  methods: {
    /**
     * "Refreshes" the UI version by simply reloading the page.
     */
    refresh: function() {
      // Add small animation to hide the panel.

      $(this.$el).addClass("uk-animation-reverse");

      setTimeout(() => {
        // After animation, do a page reload.

        location.reload();
      },500);
    }
  },

  created: function() {
    this.$router.onError((error) => {
      // Try to detect ChunkLoadError.

      let chunkLoadError = error.name === "ChunkLoadError" ||
                           error.message && /loading chunk \d* failed./i.test(error.message);

      if(chunkLoadError) {
        console.warn("RouterErrorMessage: Encountered ChunkLoadError.");
        this.showError = true;
      }
      else {
        console.warn("RouterErrorMessage: Encountered unknown error:");
        console.warn(error);

        // TODO: Should we show a different error for these? These may occur also for AxiosErrors
        //       such as http errors.
      }

      this.$emit('error');
    });
  },
}

</script>

<style scoped>
.error-pane {
  background-color: #214997;
  border-top: 1px solid #ccc;
  box-shadow: 0px 0px 10px 2px rgb(92 92 92 / 10%);
  top: 0;
  color: #fff;
  font-size: 14px;
  width: 100%;
  position: fixed;
  z-index: 100;
}

.update-button {
  min-width: 120px;
}

.uk-button:hover,
.uk-button-primary:hover,
.uk-button:focus {
  color: #ccc;
  box-shadow: 0px 0px 10px 2px rgba(92,92,92,0.2);
}
</style>
